/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: EtVLWfl2KEmA
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonDock from "../../ButtonDock"; // plasmic-import: utQE8oqBBjiK/component
import ButtonNav from "../../ButtonNav"; // plasmic-import: T4X2Gn8dCIuz/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicWebDock.module.css"; // plasmic-import: EtVLWfl2KEmA/css
import Icon29Icon from "./icons/PlasmicIcon__Icon29"; // plasmic-import: qHVc7r4OzolR/icon
import Icon30Icon from "./icons/PlasmicIcon__Icon30"; // plasmic-import: v-1PLPXOc6tO/icon
import Icon23Icon from "./icons/PlasmicIcon__Icon23"; // plasmic-import: YwlgzG5yARIP/icon
import Icon34Icon from "./icons/PlasmicIcon__Icon34"; // plasmic-import: 3VA-qZnm8pUB/icon
import Icon32Icon from "./icons/PlasmicIcon__Icon32"; // plasmic-import: dWHMt3F1tCmW/icon
import Icon33Icon from "./icons/PlasmicIcon__Icon33"; // plasmic-import: h408FMoSv0qx/icon
import Icon15Icon from "./icons/PlasmicIcon__Icon15"; // plasmic-import: KZeS8_m5UsgE/icon
import Icon27Icon from "./icons/PlasmicIcon__Icon27"; // plasmic-import: WzMsUn33Iqfb/icon
import Icon26Icon from "./icons/PlasmicIcon__Icon26"; // plasmic-import: flPWDcL8BgpD/icon
import image53VNkbZbrcdHdz from "./images/image53.svg"; // plasmic-import: VNkbZbrcdHDZ/picture

createPlasmicElementProxy;

export const PlasmicWebDock__VariantProps = new Array("isCollapsed");

export const PlasmicWebDock__ArgProps = new Array("modulesWrapper");

const $$ = {};

function PlasmicWebDock__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "isCollapsed",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isCollapsed
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"dock"}
      data-plasmic-override={overrides.dock}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.dock,
        {
          [sty.dockisCollapsed]: hasVariant(
            $state,
            "isCollapsed",
            "isCollapsed"
          )
        }
      )}
      onMouseEnter={async event => {
        const $steps = {};
      }}
      onMouseLeave={async event => {
        const $steps = {};
      }}
    >
      <div className={classNames(projectcss.all, sty.freeBox__vIglX)}>
        <Icon29Icon
          className={classNames(projectcss.all, sty.svg__wVu4C, {
            [sty.svgisCollapsed__wVu4CkTZh]: hasVariant(
              $state,
              "isCollapsed",
              "isCollapsed"
            )
          })}
          role={"img"}
        />

        <Icon29Icon
          className={classNames(projectcss.all, sty.svg__szdkc)}
          role={"img"}
        />
      </div>
      <div
        data-plasmic-name={"buttonsWrapp"}
        data-plasmic-override={overrides.buttonsWrapp}
        className={classNames(projectcss.all, sty.buttonsWrapp, {
          [sty.buttonsWrappisCollapsed]: hasVariant(
            $state,
            "isCollapsed",
            "isCollapsed"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <React.Fragment>
              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__i9DpK)}
                color={"light"}
                iconTab={
                  <div
                    className={classNames(projectcss.all, sty.freeBox__snZs)}
                  >
                    <Icon30Icon
                      className={classNames(projectcss.all, sty.svg__iDkQe)}
                      role={"img"}
                    />
                  </div>
                }
                status={"_default"}
              />

              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock___69C1D)}
                color={"light"}
                iconTab={
                  <div
                    className={classNames(projectcss.all, sty.freeBox__dTYx8)}
                  >
                    <Icon23Icon
                      className={classNames(projectcss.all, sty.svg___5H5Wl)}
                      role={"img"}
                    />
                  </div>
                }
                status={"_default"}
              />

              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__o3Ca)}
                color={"light"}
                iconTab={
                  <div
                    className={classNames(projectcss.all, sty.freeBox__xdEjH)}
                  >
                    <Icon34Icon
                      className={classNames(projectcss.all, sty.svg__mRZlH)}
                      role={"img"}
                    />
                  </div>
                }
                status={"_default"}
              />

              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__fh1Wu)}
                color={"light"}
                iconTab={
                  <div
                    className={classNames(projectcss.all, sty.freeBox__htZe)}
                  >
                    <Icon32Icon
                      className={classNames(projectcss.all, sty.svg__oKGcn)}
                      role={"img"}
                    />
                  </div>
                }
                status={"_default"}
              />

              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__qlgCi)}
                color={"light"}
                iconTab={
                  <div
                    className={classNames(projectcss.all, sty.freeBox__glpE0)}
                  >
                    <Icon33Icon
                      className={classNames(projectcss.all, sty.svg__tvtFm)}
                      role={"img"}
                    />
                  </div>
                }
                status={"_default"}
              />

              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__aujQ3)}
                color={"light"}
                iconTab={
                  <div
                    className={classNames(projectcss.all, sty.freeBox___2VIcD)}
                  >
                    <Icon15Icon
                      className={classNames(projectcss.all, sty.svg___3E6LV)}
                      role={"img"}
                    />
                  </div>
                }
                status={"_default"}
              />

              <div className={classNames(projectcss.all, sty.freeBox__gsMa2)}>
                <div
                  className={classNames(projectcss.all, sty.freeBox__x0W1A)}
                />
              </div>
              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__mqzmd)}
                color={"dark"}
                iconTab={
                  <div
                    className={classNames(projectcss.all, sty.freeBox___7Ec4H)}
                  >
                    <Icon27Icon
                      className={classNames(projectcss.all, sty.svg__eq5Ju)}
                      role={"img"}
                    />
                  </div>
                }
                status={"_default"}
              />

              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__e4Q4C)}
                color={"dark"}
                iconTab={
                  <div
                    className={classNames(projectcss.all, sty.freeBox__jM3O5)}
                  >
                    <Icon26Icon
                      className={classNames(projectcss.all, sty.svg__eua8K)}
                      role={"img"}
                    />
                  </div>
                }
                status={"_default"}
              />
            </React.Fragment>
          ),

          value: args.modulesWrapper
        })}
      </div>
      <div
        className={classNames(projectcss.all, sty.freeBox___0QiJw, {
          [sty.freeBoxisCollapsed___0QiJwkTZh]: hasVariant(
            $state,
            "isCollapsed",
            "isCollapsed"
          )
        })}
      >
        <ButtonNav
          data-plasmic-name={"iconButton3"}
          data-plasmic-override={overrides.iconButton3}
          className={classNames("__wab_instance", sty.iconButton3)}
          color={"white"}
          iconForButton={
            <PlasmicImg__
              data-plasmic-name={"img"}
              data-plasmic-override={overrides.img}
              alt={""}
              className={classNames(sty.img)}
              displayHeight={"100%"}
              displayMaxHeight={"none"}
              displayMaxWidth={"none"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"100%"}
              loading={"lazy"}
              src={{
                src: image53VNkbZbrcdHdz,
                fullWidth: 20,
                fullHeight: 20,
                aspectRatio: undefined
              }}
            />
          }
          onClick={async () => {
            const $steps = {};
            $steps["goToWebLogin"] = true
              ? (() => {
                  const actionArgs = { destination: `/login` };
                  return (({ destination }) => {
                    if (
                      typeof destination === "string" &&
                      destination.startsWith("#")
                    ) {
                      document
                        .getElementById(destination.substr(1))
                        .scrollIntoView({ behavior: "smooth" });
                    } else {
                      location.assign(destination);
                    }
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["goToWebLogin"] != null &&
              typeof $steps["goToWebLogin"] === "object" &&
              typeof $steps["goToWebLogin"].then === "function"
            ) {
              $steps["goToWebLogin"] = await $steps["goToWebLogin"];
            }
          }}
          shape={"fullRounding"}
          status={"normal"}
        />
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  dock: ["dock", "buttonsWrapp", "iconButton3", "img"],
  buttonsWrapp: ["buttonsWrapp"],
  iconButton3: ["iconButton3", "img"],
  img: ["img"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebDock__ArgProps,
          internalVariantPropNames: PlasmicWebDock__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebDock__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "dock") {
    func.displayName = "PlasmicWebDock";
  } else {
    func.displayName = `PlasmicWebDock.${nodeName}`;
  }
  return func;
}

export const PlasmicWebDock = Object.assign(
  // Top-level PlasmicWebDock renders the root element
  makeNodeComponent("dock"),
  {
    // Helper components rendering sub-elements
    buttonsWrapp: makeNodeComponent("buttonsWrapp"),
    iconButton3: makeNodeComponent("iconButton3"),
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicWebDock
    internalVariantProps: PlasmicWebDock__VariantProps,
    internalArgProps: PlasmicWebDock__ArgProps
  }
);

export default PlasmicWebDock;
/* prettier-ignore-end */
